import CryptoJS from 'crypto-js';
import Proxy from 'src/components/common/Redirect/Proxy';

export const encryptPlaintext = (plaintext) => {
    var iv = CryptoJS.lib.WordArray.random(16);

    // Convert the key and IV to WordArray objects
    var keyBytes = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_DECRYPT_KEY);
    var ivBytes = CryptoJS.enc.Hex.parse(iv.toString());

    // Perform the encryption using AES-CBC mode
    var encrypted = CryptoJS.AES.encrypt(plaintext, keyBytes, {
        iv: ivBytes,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
    });

    // Combine the IV and ciphertext into a single string
    return iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);
}



export const getIsClaimBridge = () => {
    const domain = window.location.origin;
    return domain == "https://clrevarc.aventusinformatics.com" || domain == "https://poc.claimarc.com" || domain == "https://experian.claimbridgehealth.com" || domain == "https://trizettoprovider.claimbridgehealth.com" || domain == "https://uat-trizettoprovider.claimbridgehealth.com" || domain == "https://portal.claimbridgehealth.com"|| domain == "https://portal.claimarc.com" || domain == "https://trizettoprovider.claimarc.com"

}
export const getIsDemo1Claint = ()=>{
    const domain = window.location.origin;

    return ( domain === "https://demo1.db-revarc.com"  ||  domain ==="https://quadax.db-revarc.com"  ) ;
        
}


export const handleDownloadFileUrl = async (file,isOpenDownload=false) => {
    
    try {
        if(isOpenDownload){
            window.open(Proxy(file), "_blank")
        }else{
            // Extract the file name and extension from the URL
            const OgUrl = file.split('?')[0]
            const fileName = OgUrl.split('/').pop();
            const response = await fetch(file);      
            const blob = await response.blob();
            const blobURL = URL.createObjectURL(blob);
    
            let alink = document.createElement('a');
            alink.href = blobURL;
            alink.download = fileName; // Set the extracted file name
            alink.click();
    
            // Clean up the Blob URL
            URL.revokeObjectURL(blobURL);
        }

    } catch (error) {
        console.error('Error downloading the file:', error);
    }
}



export const mergingTwoArrays = (defaultArray,changedArray)=>{
    const map = new Map();
    changedArray.forEach(item => map.set(item.id, item));
    // Step 2: Add unique items from defaultArray
    defaultArray.forEach(item => {
      if (!map.has(item.id)) {
        map.set(item.id, item);
      }
    });
    
    // Step 3: Return merged array in order of changedArray + rest
    return Array.from(map.values());
}

export const getHeaders = (computedColumns) => {
    const excludedNames = ["action"];
    const headers = computedColumns
        .map(col => col.id.trim())
        .filter(name => !excludedNames.includes(name.toLowerCase()))
        .map(name => {
            const key = name.toLowerCase();
            return key;
        })

    return headers;
}